import { Card, CardContent, CardHeader } from "@mui/material";

import { CardBlock, CardBlockHeader, CardBlockContainer, CardSpacer } from "../../../utils/utilities/CardComponents";

import { capitalize } from "lodash";

import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";

import { BasicFlex } from "../../../utils/Common";

import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import { formatPhoneNumber, displayTruncated, formatGenericDate } from "../../../utils/util";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { DateTime } from "luxon";

const Sidebar = () => {
  const { values } = useFormikContext() || {};

  const { formValues } = useFormData() || {};

  let total_duration = values?.repairs?.reduce((total, repair) => total + +repair.estimated_time_to_complete, 0)
  let eta = DateTime.local().plus({days: total_duration}).toLocaleString(DateTime.DATE_FULL);

  let total_price = values?.repairs?.reduce((total, repair) => total + +repair.price, 0)

  let cust_block = [
    { header: "Customer", info: formValues.customer_name, icon: <AccountBoxOutlinedIcon fontSize="small" />, spread: "11rem"  },
    { header: "Phone", info: formatPhoneNumber(formValues.customer_phone), icon: <AccountBoxOutlinedIcon fontSize="small" />, spread: "11rem"  },
  ]

  const wig_details = [
    { header: "Source", info: capitalize(values?.wig_source), spread: "7rem" },
    { header: "Wig ID", info: values?.wig_id, spread: "7rem"  },
    { header: "SKU", info: <SimpleChip label={displayTruncated(formValues?.sku, {length: 25})} size="small" uc={true} />, spread: "7rem"  },
  ]

  const repair_summary = [
    {
      header: "No. of Repairs",
      info: values?.repairs?.length,
      dataType: "number",
      spread: "11rem"
    },
    {
      header: "Total Price",
      info: total_price,
      dataType: "currency",
      spread: "11rem"
    },
    {
      header: "Total Duration",
      info: `${total_duration} Days`,
      spread: "11rem"
    },
    {
      header: "ETA",
      info: eta,
      spread: "11rem"
    },
    {
      header: "Due Date",
      info: formatGenericDate(values?.due_date),
      spread: "11rem"
    },
  ];

  let follow_up = [
    {
      header: "Follow Up Service",
      info: values?.follow_up_service,
      // dataType: "date",
      spread: "11rem"
    }
  ]


  return (
    <BasicFlex dir="column" gap="1.6rem">
      <Card variant="outlined" sx={{width: "100%"}}>
        <CardHeader title="Customer Details" />
        <CardContent>
          <CardBlockContainer>
            {cust_block.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
          </CardBlockContainer>
        </CardContent>
      </Card>

      <Card variant="outlined" sx={{width: "100%"}}>
        <CardHeader title="Repair Ticket Summary" sx={{pb: 1}} />
        <CardContent>
          <CardBlockContainer gap="1rem">

          <CardBlockHeader>Wig Details</CardBlockHeader>
            {wig_details.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />

            <CardBlockHeader>Repair Summary</CardBlockHeader>
            {repair_summary.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}

            <CardSpacer />

            <CardBlockHeader>Follow Up Service</CardBlockHeader>
            {follow_up.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
          </CardBlockContainer>
        </CardContent>
      </Card>
    </BasicFlex>
  )
};

export default Sidebar;